import { ApplicationType } from "./enums";

export function GetValueFromEnum<T extends Record<string, unknown>>(
  enumObject: T,
  searchStr: string
): string | null {
  const filtered = Object.entries(enumObject).filter(t => t[0] === searchStr);
  return filtered.length === 0 ? null : (filtered[0][1] as string);
}

export function GetApplicationTypeString(
  applicationType: ApplicationType
): string {
  switch (applicationType) {
    case ApplicationType.Excavation:
      return "Excavation";
    case ApplicationType.NonExcavation:
      return "Non-Excavation";
    case ApplicationType.Preliminary:
      return "Preliminary";
    case ApplicationType.Event:
      return "Event";
    case ApplicationType.Retrospective:
      return "Emergency";
  }
}
